var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUtilizeTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 92,
    viewBox: "0 0 99 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 67.7289V89M3 78.3644H18.267C20.4078 78.3644 21.4783 78.3644 22.3959 78.0113C23.2065 77.6992 23.9282 77.1919 24.4977 76.5346C25.1424 75.7906 25.5082 74.7813 26.2398 72.7638L34.8138 49.1167M71.93 59.7522L81.1379 64.3696C83.5096 65.5592 84.6952 66.1538 85.8639 66.1883C86.893 66.2192 87.9089 65.9485 88.7875 65.4098C89.7849 64.7983 90.5203 63.6922 91.9912 61.4794L93.1105 59.7953C94.953 57.0237 95.874 55.6378 95.9833 54.26C96.0792 53.0502 95.7601 51.8441 95.0782 50.8417C94.3014 49.6995 92.8162 48.955 89.8459 47.4655L87.8368 46.4578M7.55934 25.3245L17.4805 8.26723C18.9141 5.80228 19.631 4.56983 20.6588 3.88612C21.5634 3.28436 22.6305 2.97556 23.7157 3.00151C24.9487 3.03092 26.21 3.69091 28.7327 5.01094L70.5959 26.9163C74.5588 28.99 76.5403 30.0268 77.3113 31.4956C77.9852 32.7785 78.1071 34.2817 77.6495 35.6572C77.1257 37.2318 75.3377 38.5768 71.7619 41.2665L54.9154 53.9383C53.3926 55.0837 52.6312 55.6565 51.785 55.9293C51.0368 56.1707 50.2446 56.2425 49.4657 56.1393C48.5845 56.0223 47.7335 55.5953 46.0309 54.7418L11.0933 37.2218C8.27854 35.8103 6.87115 35.1046 6.10364 34.0186C5.42914 33.0641 5.0873 31.9132 5.13104 30.7441C5.18078 29.4139 5.97363 28.0508 7.55934 25.3245Z",
    stroke: "#3BB1E6",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUtilizeTwo);
export default __webpack_public_path__ + "static/media/utilize-two.027ce008736191d077e81a9e028f0a94.svg";
export { ForwardRef as ReactComponent };